export const state = {
  notifications: [],
}

export const getters = {}

export const mutations = {
  ADD(state, payload) {
    state.notifications.push({
      ...payload,
      id: payload.id ? payload.id : determineMaxID(state.notifications) + 1,
    })
  },
  DELETE(state, itemId) {
    const index = state.notifications.findIndex(x => x.id === itemId)
    if (index !== -1) state.notifications.splice(index, 1)
  },
}

export const actions = {}

function determineMaxID(array) {
  if (!array.length) return 0
  return Math.max.apply(Math, array.map(x => x.id))
}
